/**
 * resolveTeamLogo — Auto-resolve ESPN CDN team logo URLs
 * for NBA and MLB teams that don't have logoUrl in the database.
 *
 * Usage:
 *   const url = resolveTeamLogo("nba", "LA Lakers");
 *   // → "https://a.espncdn.com/i/teamlogos/nba/500/lal.png"
 */

const ESPN_NBA_BASE = "https://a.espncdn.com/i/teamlogos/nba/500/";
const ESPN_MLB_BASE = "https://a.espncdn.com/i/teamlogos/mlb/500/";

// NBA team name → ESPN abbreviation
const NBA_SLUGS = {
  "atlanta hawks": "atl",
  "boston celtics": "bos",
  "brooklyn nets": "bkn",
  "charlotte hornets": "cha",
  "chicago bulls": "chi",
  "cleveland cavaliers": "cle",
  "dallas mavericks": "dal",
  "denver nuggets": "den",
  "detroit pistons": "det",
  "golden state warriors": "gs",
  "houston rockets": "hou",
  "indiana pacers": "ind",
  "la clippers": "lac",
  "los angeles clippers": "lac",
  "la lakers": "lal",
  "los angeles lakers": "lal",
  "memphis grizzlies": "mem",
  "miami heat": "mia",
  "milwaukee bucks": "mil",
  "minnesota timberwolves": "min",
  "new orleans pelicans": "no",
  "new york knicks": "ny",
  "oklahoma city thunder": "okc",
  "orlando magic": "orl",
  "philadelphia 76ers": "phi",
  "philadelphia sixers": "phi",
  "phoenix suns": "phx",
  "portland trail blazers": "por",
  "sacramento kings": "sac",
  "san antonio spurs": "sa",
  "toronto raptors": "tor",
  "utah jazz": "utah",
  "washington wizards": "wsh",
};

// MLB team name → ESPN abbreviation
const MLB_SLUGS = {
  "arizona diamondbacks": "ari",
  "atlanta braves": "atl",
  "baltimore orioles": "bal",
  "boston red sox": "bos",
  "chicago cubs": "chc",
  "chicago white sox": "chw",
  "cincinnati reds": "cin",
  "cleveland guardians": "cle",
  "colorado rockies": "col",
  "detroit tigers": "det",
  "houston astros": "hou",
  "kansas city royals": "kc",
  "los angeles angels": "laa",
  "los angeles dodgers": "lad",
  "miami marlins": "mia",
  "milwaukee brewers": "mil",
  "minnesota twins": "min",
  "new york mets": "nym",
  "new york yankees": "nyy",
  "oakland athletics": "oak",
  "philadelphia phillies": "phi",
  "pittsburgh pirates": "pit",
  "san diego padres": "sd",
  "san francisco giants": "sf",
  "seattle mariners": "sea",
  "st. louis cardinals": "stl",
  "st louis cardinals": "stl",
  "tampa bay rays": "tb",
  "texas rangers": "tex",
  "toronto blue jays": "tor",
  "washington nationals": "wsh",
};

/**
 * Returns the ESPN CDN logo URL for a team if known, otherwise null.
 * @param {string} sport — "nba" | "mlb" | "football"
 * @param {string} teamName — Team full name
 * @returns {string|null}
 */
export function resolveTeamLogo(sport, teamName) {
  if (!teamName || !sport) return null;
  const key = teamName.toLowerCase().trim();
  if (sport === "nba") {
    const slug = NBA_SLUGS[key];
    return slug ? `${ESPN_NBA_BASE}${slug}.png` : null;
  }
  if (sport === "mlb") {
    const slug = MLB_SLUGS[key];
    return slug ? `${ESPN_MLB_BASE}${slug}.png` : null;
  }
  return null;
}
